// QR Kiosk v2 — mono "EN ▾" language chip in the chrome bar.
// The visible chip stays small; the <button> pads out to a ≥44px tap target.
// Tap → the settings surface (language switching lives there, KV2-4) when a
// machine number is resolvable from the path; otherwise a no-op.
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useTranslation from "../../../shared/hooks/useTranslation";

export function LanguageChip() {
  const { i18n, translate } = useTranslation("public");
  const navigate = useNavigate();
  const location = useLocation();

  // Normalized-code rule — the v1 regional-code bug never enters v2.
  const lang = i18n.language.split("-")[0].toUpperCase();

  const machineMatch = location.pathname.match(/\/machines\/([^/]+)/);
  const machineNumber = machineMatch ? machineMatch[1] : undefined;

  const handleClick = () => {
    if (machineNumber) navigate(`/public-v2/machines/${machineNumber}/settings`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={translate("kioskLanguage")}
      style={{
        border: 0,
        background: "transparent",
        cursor: "pointer",
        padding: "12px 8px",
        margin: "-12px -8px",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <span
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 10.5,
          color: "var(--muted)",
          letterSpacing: "0.04em",
        }}
      >
        {lang} {"▾"}
      </span>
    </button>
  );
}

export default LanguageChip;
